if (!customElements.get('awards-carousel')) {
  class AwardsCarousel extends HTMLElement {
    constructor () {
      super();
      this.swiper = null;
    }

    connectedCallback () {
      if (window.Swiper !== undefined) {
        this.initSwiper();
      }
    }

    disconnectedCallback () {
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
    }

    initSwiper () {
      const swiper_element = this.querySelector('.swiper');
      const swiper_pagination = this.querySelector('.swiper-pagination');

      this.swiper = new Swiper(swiper_element, {
        slidesPerView: 1,
        grabCursor: true,
        spaceBetween: 20,
        centeredSlides: false,
        loop: true,
        effect: 'coverflow',
        coverflowEffect: {
          rotate: -2,
          slideShadows: false,
          stretch: -20,
        },
        mousewheel: {
          forceToAxis: true
        },
        breakpoints: {
          991: {
            centeredSlides: true,
            spaceBetween: 20,
            slidesPerView: 3.5,
            grabCursor: false
          },
          767: {
            centeredSlides: true,
            spaceBetween: 20,
            slidesPerView: 2.9,
            grabCursor: false
          }
        },
        pagination: {
          el: swiper_pagination,
          clickable: true
        }
      });
    }
  }

  customElements.define('awards-carousel', AwardsCarousel);
}